var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileTypePhotoshop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_photoshop2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    points: "24.099 2 8.837 2 8.837 30 8.909 30 29.747 30 29.747 7.888 24.168 2.072 24.099 2",
    style: {
      fill: "#070444"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.253,
    y: 3.493,
    width: 20.307,
    height: 7.844,
    style: {
      fill: "#5bc3f6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.099 2 24.099 7.888 29.747 7.888 24.099 2",
    style: {
      fill: "#5bc3f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1,4.987a6,6,0,0,1,1.242-.1,1.576,1.576,0,0,1,1.187.392,1.714,1.714,0,0,1,.429,1.207A1.946,1.946,0,0,1,9.6,7.712a1.565,1.565,0,0,1-1.254.518A2.084,2.084,0,0,1,8.1,8.215v1.7h-1Zm1,2.206a1.61,1.61,0,0,0,.228.015.621.621,0,0,0,.641-.7A.546.546,0,0,0,8.4,5.89a1.166,1.166,0,0,0-.3.03Z",
    style: {
      fill: "#070444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.083,8.578a1.845,1.845,0,0,0,.975.311c.345,0,.513-.156.513-.407S12.4,8.1,11.98,7.9a1.594,1.594,0,0,1-1.053-1.5,1.454,1.454,0,0,1,1.5-1.562,1.925,1.925,0,0,1,1.02.259L13.24,6.164a1.576,1.576,0,0,0-.819-.237c-.306,0-.474.148-.474.37,0,.252.2.355.674.592a1.543,1.543,0,0,1,.981,1.5,1.494,1.494,0,0,1-1.6,1.6,2.117,2.117,0,0,1-1.1-.311Z",
    style: {
      fill: "#070444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.62,8.98l-.1,0V5.755h.014a1.117,1.117,0,0,1,.629.113,1.262,1.262,0,0,1,.341.422,1.369,1.369,0,0,1,.149.553c.01.231,0,.417,0,.578a3.079,3.079,0,0,1-.035.539,1.846,1.846,0,0,1-.178.529,1.187,1.187,0,0,1-.382.379.707.707,0,0,1-.437.111m.192-4.141c-.117,0-.23.009-.31.012l-.247.007h-.82V9.911H15.4a2.815,2.815,0,0,0,1.082-.184A1.8,1.8,0,0,0,17.2,9.21a2.04,2.04,0,0,0,.392-.788,3.921,3.921,0,0,0,.12-1,4.644,4.644,0,0,0-.092-1.186,1.868,1.868,0,0,0-.425-.771,1.712,1.712,0,0,0-.563-.422,2.537,2.537,0,0,0-.577-.188,1.349,1.349,0,0,0-.24-.018",
    style: {
      fill: "#070444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,19.651a7.218,7.218,0,0,1-.9-.031V16.13c.111-.016.5-.031,1.04-.031,1.3,0,1.873.546,1.873,1.791,0,1.556-.916,1.761-2.012,1.761m.139-5.031c-1.054,0-2.095.016-2.622.031-.069,0-.083.031-.083.109v9.93c0,.078.028.109.1.109H15c.069,0,.1-.031.1-.125V21.13h.86c2.039,0,3.718-.658,3.718-3.132-.014-1.805-.818-3.378-3.538-3.378",
    style: {
      fill: "#5bc3f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.075,17.218a2.266,2.266,0,0,0-2.539,2.257c0,1.136.5,1.743,1.928,2.4,1,.451,1.249.685,1.249,1.089,0,.342-.222.7-.86.7a4.067,4.067,0,0,1-2.247-.841.056.056,0,0,0-.034-.012c-.033,0-.063.032-.063.09v1.432a.159.159,0,0,0,.083.156,3.942,3.942,0,0,0,2.15.607,2.317,2.317,0,0,0,2.594-2.4c0-1.121-.61-1.7-2.039-2.35-1.04-.467-1.221-.669-1.221-1.043,0-.3.18-.654.86-.654a3.8,3.8,0,0,1,1.928.591.094.094,0,0,0,.052.018c.043,0,.073-.043.073-.112V17.872a.224.224,0,0,0-.083-.2,3.365,3.365,0,0,0-1.831-.451",
    style: {
      fill: "#5bc3f6"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTypePhotoshop);
export default __webpack_public_path__ + "static/media/file_type_photoshop.28060564.svg";
export { ForwardRef as ReactComponent };